export const DIAGNOSIS_CODES = [
  'H906',
  'A043',
  'A01.0',
  'A01.1',
  'A01.2',
  'A01.3',
  'A01.4',
  'A25.9',
  'A38',
  'A48.2',
  'A48.4',
  'A68.0',
  'A68.1',
  'A68.9',
  'A75',
  'A77',
  'A78',
  'A79.0',
  'A88.0',
  'A90',
  'A91',
  'A92.1',
  'A92.2',
  'A92.4',
  'A92.9',
  'A93.1',
  'A93.2',
  'A94',
  'A95',
  'A96',
  'A98.0',
  'A98.1',
  'A98.5',
  'A99',
  'I00',
  'I01',
  'M04.1',
  'R50',
  'R68.83',
];
export const DIAGNOSIS_CODES_NEW = [];
export const diagnosisNewSchema = [];

export const DIAGNOSIS_DESC = [
  'Mixed conductive and sensorineural hearing loss',
  'Enterohemorrhagic Escherichia coli infection',
  'Typhoid fever',
  'Paratyphoid fever A',
  'Paratyphoid fever B',
  'Paratyphoid fever C',
  'Paratyphoid fever, unspecified',
  'Rat-bite fever, unspecified',
  'Scarlet fever',
  "Nonpneumonic Legionnaires' disease [Pontiac fever]",
  'Brazilian purpuric fever',
  'Louse-borne relapsing fever',
  'Tick-borne relapsing fever',
  'Relapsing fever, unspecified',
  'Typhus fever',
  'Spotted fever [tick-borne rickettsioses]',
  'Q fever',
  'Trench fever',
  'Enteroviral exanthematous fever [Boston exanthem]',
  'Dengue fever [classical dengue]',
  'Dengue hemorrhagic fever',
  "O'nyong-nyong fever",
  'Venezuelan equine fever',
  'Rift Valley fever',
  'Mosquito-borne viral fever, unspecified',
  'Sandfly fever',
  'Colorado tick fever',
  'Unspecified arthropod-borne viral fever',
  'Yellow fever',
  'Arenaviral hemorrhagic fever',
  'Crimean-Congo hemorrhagic fever',
  'Omsk hemorrhagic fever',
  'Hemorrhagic fever with renal syndrome',
  'Unspecified viral hemorrhagic fever',
  'Rheumatic fever without heart involvement',
  'Rheumatic fever with heart involvement',
  'Periodic fever syndromes',
  'Fever of other and unknown origin',
  'Chills (without fever)',
];

export const PROCEDURE_CODE = [
  'Q5001',
  'T1028',
  'G9006',
  'S0281',
  'S9098',
  'S9209',
  'S9529',
];
export const FORM_TYPE = ['Patient', 'Doctor', 'Other'];
export const PROCEDURE_TYPE = [
  'Minimal',
  'Problem focused',
  'Expanded problem focused',
  'Detailed',
  'Comprehensive',
  'Significant, separate service',
  'Anoscopy',
  'Audiometry',
  'Colposcopy',
  'Colposcopy w/biopsy',
  'ECG, w/interpretation',
  'ECG, rhythm strip',
  'Endometrial biopsy',
  'Flexible sigmoidoscopy',
  'Flexible sigmoidoscopy w/biopsy',
  'Cerumen removal',
  'Venipuncture',
  'CBC, w/ auto differential',
  'CBC, w/o auto differential',
  'Cholesterol',
  'Hemoccult, guaiac',
  'Hemoccult, immunoassay',
  'Hemoglobin A1C',
  'Lipid panel',
  'Liver panel',
  'Blood glucose, monitoring device',
  'Blood glucose, visual dipstick',
];
export const Pro_Codes = [];
export const Pro_Codes_Description = [];
export const MODIFIER_CODE = [];
export const MODIFIER_CODE_DES = [];
export const PLACE_OF_SREVICE = [
  { id: '01', label: 'Pharmacy' },
  { id: '02', label: 'Telehealth' },
  { id: '03', label: 'School' },
  { id: '11', label: 'Office' },
  { id: '12', label: 'Home' },
  { id: '13', label: 'Assisted Living Facility' },
  { id: '21', label: 'Inpatient Hospital' },
  { id: '52', label: 'Psychiatric Facility-Partial Hospitalization' },
  { id: '56', label: 'Psychiatric Residential Treatment Center' },
];

export const DIAGNOSIS_SEQUENCE = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const PROCEDURE_DESC = [
  'Hospice or home hlth in home',
  'Home environment assessment',
  'Mccd, home monitoring',
  'Medical home, maintenance',
  'Home phototherapy visit',
  'Home mgmt pprom',
  'Venipuncture home/snf',
];

export const diagnosisSchema = [
  {
    _id: {
      _id: {
        $id: '559c1bb3671d624c3e8caacd',
      },
      codeSet: 'icd10',
      leaf: false,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'H906',
    desc: 'Mixed conductive and sensorineural hearing loss',
    codeSet: 'icd10',
    normalizedCode: 'A010',
    levenshtein: 13,
    hasChildren: true,
  },
  {
    _id: {
      _id: {
        $id: '559c1bb3671d624c3e8caacd',
      },
      codeSet: 'icd10',
      leaf: false,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A043',
    desc: 'Enterohemorrhagic Escherichia coli infection',
    codeSet: 'icd10',
    normalizedCode: 'A010',
    levenshtein: 13,
    hasChildren: true,
  },
  {
    _id: {
      _id: {
        $id: '559c1bb3671d624c3e8caacd',
      },
      codeSet: 'icd10',
      leaf: false,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A01.0',
    desc: 'Typhoid fever',
    codeSet: 'icd10',
    normalizedCode: 'A010',
    levenshtein: 13,
    hasChildren: true,
  },
  {
    _id: {
      _id: {
        $id: '559c25f0671d6243478caad6',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A01.1',
    desc: 'Paratyphoid fever A',
    codeSet: 'icd10',
    normalizedCode: 'A011',
    levenshtein: 19,
  },
  {
    _id: {
      _id: {
        $id: '559c25f0671d6243478caad7',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A01.2',
    desc: 'Paratyphoid fever B',
    codeSet: 'icd10',
    normalizedCode: 'A012',
    levenshtein: 19,
  },
  {
    _id: {
      _id: {
        $id: '559c25f0671d6243478caad8',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A01.3',
    desc: 'Paratyphoid fever C',
    codeSet: 'icd10',
    normalizedCode: 'A013',
    levenshtein: 19,
  },
  {
    _id: {
      _id: {
        $id: '559c25f0671d6243478caad9',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A01.4',
    desc: 'Paratyphoid fever, unspecified',
    codeSet: 'icd10',
    normalizedCode: 'A014',
    levenshtein: 30,
  },
  {
    _id: {
      _id: {
        $id: '559c25fb671d6243478cab6e',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A25.9',
    desc: 'Rat-bite fever, unspecified',
    codeSet: 'icd10',
    normalizedCode: 'A259',
    levenshtein: 27,
  },
  {
    _id: {
      _id: {
        $id: '559c1bb3671d624c3e8caafa',
      },
      codeSet: 'icd10',
      leaf: false,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A38',
    desc: 'Scarlet fever',
    codeSet: 'icd10',
    normalizedCode: 'A38',
    levenshtein: 13,
    hasChildren: true,
  },
  {
    _id: {
      _id: {
        $id: '559c2607671d6243478cabe1',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A48.2',
    desc: "Nonpneumonic Legionnaires' disease [Pontiac fever]",
    codeSet: 'icd10',
    normalizedCode: 'A482',
    levenshtein: 50,
  },
  {
    _id: {
      _id: {
        $id: '559c2607671d6243478cabe3',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A48.4',
    desc: 'Brazilian purpuric fever',
    codeSet: 'icd10',
    normalizedCode: 'A484',
    levenshtein: 24,
  },
  {
    _id: {
      _id: {
        $id: '559c261d671d6243478cac8c',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A68.0',
    desc: 'Louse-borne relapsing fever',
    codeSet: 'icd10',
    normalizedCode: 'A680',
    levenshtein: 27,
  },
  {
    _id: {
      _id: {
        $id: '559c261d671d6243478cac8d',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A68.1',
    desc: 'Tick-borne relapsing fever',
    codeSet: 'icd10',
    normalizedCode: 'A681',
    levenshtein: 26,
  },
  {
    _id: {
      _id: {
        $id: '559c261d671d6243478cac8e',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A68.9',
    desc: 'Relapsing fever, unspecified',
    codeSet: 'icd10',
    normalizedCode: 'A689',
    levenshtein: 28,
  },
  {
    _id: {
      _id: {
        $id: '559c1bb3671d624c3e8cab2e',
      },
      codeSet: 'icd10',
      leaf: false,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A75',
    desc: 'Typhus fever',
    codeSet: 'icd10',
    normalizedCode: 'A75',
    levenshtein: 12,
    hasChildren: true,
  },
  {
    _id: {
      _id: {
        $id: '559c1bb3671d624c3e8cab2f',
      },
      codeSet: 'icd10',
      leaf: false,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A77',
    desc: 'Spotted fever [tick-borne rickettsioses]',
    codeSet: 'icd10',
    normalizedCode: 'A77',
    levenshtein: 40,
    hasChildren: true,
  },
  {
    _id: {
      _id: {
        $id: '559c261d671d6243478cacae',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A78',
    desc: 'Q fever',
    codeSet: 'icd10',
    normalizedCode: 'A78',
    levenshtein: 7,
  },
  {
    _id: {
      _id: {
        $id: '559c261d671d6243478cacaf',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A79.0',
    desc: 'Trench fever',
    codeSet: 'icd10',
    normalizedCode: 'A790',
    levenshtein: 12,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cacdf',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A88.0',
    desc: 'Enteroviral exanthematous fever [Boston exanthem]',
    codeSet: 'icd10',
    normalizedCode: 'A880',
    levenshtein: 49,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cace3',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A90',
    desc: 'Dengue fever [classical dengue]',
    codeSet: 'icd10',
    normalizedCode: 'A90',
    levenshtein: 31,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cace4',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A91',
    desc: 'Dengue hemorrhagic fever',
    codeSet: 'icd10',
    normalizedCode: 'A91',
    levenshtein: 24,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cace6',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A92.1',
    desc: "O'nyong-nyong fever",
    codeSet: 'icd10',
    normalizedCode: 'A921',
    levenshtein: 19,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cace7',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A92.2',
    desc: 'Venezuelan equine fever',
    codeSet: 'icd10',
    normalizedCode: 'A922',
    levenshtein: 23,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cacec',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A92.4',
    desc: 'Rift Valley fever',
    codeSet: 'icd10',
    normalizedCode: 'A924',
    levenshtein: 17,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cacee',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A92.9',
    desc: 'Mosquito-borne viral fever, unspecified',
    codeSet: 'icd10',
    normalizedCode: 'A929',
    levenshtein: 39,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cacf0',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A93.1',
    desc: 'Sandfly fever',
    codeSet: 'icd10',
    normalizedCode: 'A931',
    levenshtein: 13,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cacf1',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A93.2',
    desc: 'Colorado tick fever',
    codeSet: 'icd10',
    normalizedCode: 'A932',
    levenshtein: 19,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cacf3',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A94',
    desc: 'Unspecified arthropod-borne viral fever',
    codeSet: 'icd10',
    normalizedCode: 'A94',
    levenshtein: 39,
  },
  {
    _id: {
      _id: {
        $id: '559c1bbe671d624c3e8cab41',
      },
      codeSet: 'icd10',
      leaf: false,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A95',
    desc: 'Yellow fever',
    codeSet: 'icd10',
    normalizedCode: 'A95',
    levenshtein: 12,
    hasChildren: true,
  },
  {
    _id: {
      _id: {
        $id: '559c1bbe671d624c3e8cab42',
      },
      codeSet: 'icd10',
      leaf: false,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A96',
    desc: 'Arenaviral hemorrhagic fever',
    codeSet: 'icd10',
    normalizedCode: 'A96',
    levenshtein: 28,
    hasChildren: true,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cacfc',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A98.0',
    desc: 'Crimean-Congo hemorrhagic fever',
    codeSet: 'icd10',
    normalizedCode: 'A980',
    levenshtein: 31,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cacfd',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A98.1',
    desc: 'Omsk hemorrhagic fever',
    codeSet: 'icd10',
    normalizedCode: 'A981',
    levenshtein: 22,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cad01',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A98.5',
    desc: 'Hemorrhagic fever with renal syndrome',
    codeSet: 'icd10',
    normalizedCode: 'A985',
    levenshtein: 37,
  },
  {
    _id: {
      _id: {
        $id: '559c2628671d6243478cad03',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'A99',
    desc: 'Unspecified viral hemorrhagic fever',
    codeSet: 'icd10',
    normalizedCode: 'A99',
    levenshtein: 35,
  },
  {
    _id: {
      _id: {
        $id: '559c2968671d6243478cc9f6',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'I00',
    desc: 'Rheumatic fever without heart involvement',
    codeSet: 'icd10',
    normalizedCode: 'I00',
    levenshtein: 41,
  },
  {
    _id: {
      _id: {
        $id: '559c1ca5671d624c3e8cb370',
      },
      codeSet: 'icd10',
      leaf: false,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'I01',
    desc: 'Rheumatic fever with heart involvement',
    codeSet: 'icd10',
    normalizedCode: 'I01',
    levenshtein: 38,
  },
  {
    _id: {
      _id: {
        $id: '57fe5627f2060fe8778b4c7c',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'M04.1',
    desc: 'Periodic fever syndromes',
    codeSet: 'icd10',
    normalizedCode: 'M041',
    levenshtein: 24,
  },
  {
    _id: {
      _id: {
        $id: '559c1e3e671d624c3e8cc1e9',
      },
      codeSet: 'icd10',
      leaf: false,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'R50',
    desc: 'Fever of other and unknown origin',
    codeSet: 'icd10',
    normalizedCode: 'R50',
    levenshtein: 33,
    hasChildren: true,
  },
  {
    _id: {
      _id: {
        $id: '559c3030671d6243478cffd2',
      },
      codeSet: 'icd10',
      leaf: true,
    },
    score: 1,
    threeWords: 0,
    twoWords: 0,
    oneWord: 1,
    name: 'R68.83',
    desc: 'Chills (without fever)',
    codeSet: 'icd10',
    normalizedCode: 'R6883',
    levenshtein: 22,
  },
];

export const procedureNewSchema = [];

export const procedureSchema = [
  {
    code: 'Q5001',
    description: 'Hospice or home hlth in home',
  },
  {
    code: 'T1028',
    description: 'Home environment assessment',
  },
  {
    code: 'G9006',
    description: 'Mccd, home monitoring',
  },
  {
    code: 'S0281',
    description: 'Medical home, maintenance',
  },
  {
    code: 'S9098',
    description: 'Home phototherapy visit',
  },
  {
    code: 'S9209',
    description: 'Home mgmt pprom',
  },
  {
    code: 'S9529',
    description: 'Venipuncture home/snf',
  },
];

export const updateProcedureSchema = [
  {
    procedureCode: 'Q5001',
    description: 'Hospice or home hlth in home',
  },
  {
    procedureCode: 'T1028',
    description: 'Home environment assessment',
  },
  {
    procedureCode: 'G9006',
    description: 'Mccd, home monitoring',
  },
  {
    procedureCode: 'S0281',
    description: 'Medical home, maintenance',
  },
  {
    procedureCode: 'S9098',
    description: 'Home phototherapy visit',
  },
  {
    procedureCode: 'S9209',
    description: 'Home mgmt pprom',
  },
  {
    procedureCode: 'S9529',
    description: 'Venipuncture home/snf',
  },
];

export const STATE_CITES = {
  'New York': [
    'New York',
    'Buffalo',
    'Rochester',
    'Yonkers',
    'Syracuse',
    'Albany',
    'New Rochelle',
    'Mount Vernon',
    'Schenectady',
    'Utica',
    'White Plains',
    'Hempstead',
    'Troy',
    'Niagara Falls',
    'Binghamton',
    'Freeport',
    'Valley Stream',
  ],
  California: [
    'Los Angeles',
    'San Diego',
    'San Jose',
    'San Francisco',
    'Fresno',
    'Sacramento',
    'Long Beach',
    'Oakland',
    'Bakersfield',
    'Anaheim',
    'Santa Ana',
    'Riverside',
    'Stockton',
    'Chula Vista',
    'Irvine',
    'Fremont',
    'San Bernardino',
    'Modesto',
    'Fontana',
    'Oxnard',
    'Moreno Valley',
    'Huntington Beach',
    'Glendale',
    'Santa Clarita',
    'Garden Grove',
    'Oceanside',
    'Rancho Cucamonga',
    'Santa Rosa',
    'Ontario',
    'Lancaster',
    'Elk Grove',
    'Corona',
    'Palmdale',
    'Salinas',
    'Pomona',
    'Hayward',
    'Escondido',
    'Torrance',
    'Sunnyvale',
    'Orange',
    'Fullerton',
    'Pasadena',
    'Thousand Oaks',
    'Visalia',
    'Simi Valley',
    'Concord',
    'Roseville',
    'Victorville',
    'Santa Clara',
    'Vallejo',
    'Berkeley',
    'El Monte',
    'Downey',
    'Costa Mesa',
    'Inglewood',
    'Carlsbad',
    'San Buenaventura (Ventura)',
    'Fairfield',
    'West Covina',
    'Murrieta',
    'Richmond',
    'Norwalk',
    'Antioch',
    'Temecula',
    'Burbank',
    'Daly City',
    'Rialto',
    'Santa Maria',
    'El Cajon',
    'San Mateo',
    'Clovis',
    'Compton',
    'Jurupa Valley',
    'Vista',
    'South Gate',
    'Mission Viejo',
    'Vacaville',
    'Carson',
    'Hesperia',
    'Santa Monica',
    'Westminster',
    'Redding',
    'Santa Barbara',
    'Chico',
    'Newport Beach',
    'San Leandro',
    'San Marcos',
    'Whittier',
    'Hawthorne',
    'Citrus Heights',
    'Tracy',
    'Alhambra',
    'Livermore',
    'Buena Park',
    'Menifee',
    'Hemet',
    'Lakewood',
    'Merced',
    'Chino',
    'Indio',
    'Redwood City',
    'Lake Forest',
    'Napa',
    'Tustin',
    'Bellflower',
    'Mountain View',
    'Chino Hills',
    'Baldwin Park',
    'Alameda',
    'Upland',
    'San Ramon',
    'Folsom',
    'Pleasanton',
    'Union City',
    'Perris',
    'Manteca',
    'Lynwood',
    'Apple Valley',
    'Redlands',
    'Turlock',
    'Milpitas',
    'Redondo Beach',
    'Rancho Cordova',
    'Yorba Linda',
    'Palo Alto',
    'Davis',
    'Camarillo',
    'Walnut Creek',
    'Pittsburg',
    'South San Francisco',
    'Yuba City',
    'San Clemente',
    'Laguna Niguel',
    'Pico Rivera',
    'Montebello',
    'Lodi',
    'Madera',
    'Santa Cruz',
    'La Habra',
    'Encinitas',
    'Monterey Park',
    'Tulare',
    'Cupertino',
    'Gardena',
    'National City',
    'Rocklin',
    'Petaluma',
    'Huntington Park',
    'San Rafael',
    'La Mesa',
    'Arcadia',
    'Fountain Valley',
    'Diamond Bar',
    'Woodland',
    'Santee',
    'Lake Elsinore',
    'Porterville',
    'Paramount',
    'Eastvale',
    'Rosemead',
    'Hanford',
    'Highland',
    'Brentwood',
    'Novato',
    'Colton',
    'Cathedral City',
    'Delano',
    'Yucaipa',
    'Watsonville',
    'Placentia',
    'Glendora',
    'Gilroy',
    'Palm Desert',
    'Cerritos',
    'West Sacramento',
    'Aliso Viejo',
    'Poway',
    'La Mirada',
    'Rancho Santa Margarita',
    'Cypress',
    'Dublin',
    'Covina',
    'Azusa',
    'Palm Springs',
    'San Luis Obispo',
    'Ceres',
    'San Jacinto',
    'Lincoln',
    'Newark',
    'Lompoc',
    'El Centro',
    'Danville',
    'Bell Gardens',
    'Coachella',
    'Rancho Palos Verdes',
    'San Bruno',
    'Rohnert Park',
    'Brea',
    'La Puente',
    'Campbell',
    'San Gabriel',
    'Beaumont',
    'Morgan Hill',
    'Culver City',
    'Calexico',
    'Stanton',
    'La Quinta',
    'Pacifica',
    'Montclair',
    'Oakley',
    'Monrovia',
    'Los Banos',
    'Martinez',
  ],
  Illinois: [
    'Chicago',
    'Aurora',
    'Rockford',
    'Joliet',
    'Naperville',
    'Springfield',
    'Peoria',
    'Elgin',
    'Waukegan',
    'Cicero',
    'Champaign',
    'Bloomington',
    'Arlington Heights',
    'Evanston',
    'Decatur',
    'Schaumburg',
    'Bolingbrook',
    'Palatine',
    'Skokie',
    'Des Plaines',
    'Orland Park',
    'Tinley Park',
    'Oak Lawn',
    'Berwyn',
    'Mount Prospect',
    'Normal',
    'Wheaton',
    'Hoffman Estates',
    'Oak Park',
    'Downers Grove',
    'Elmhurst',
    'Glenview',
    'DeKalb',
    'Lombard',
    'Belleville',
    'Moline',
    'Buffalo Grove',
    'Bartlett',
    'Urbana',
    'Quincy',
    'Crystal Lake',
    'Plainfield',
    'Streamwood',
    'Carol Stream',
    'Romeoville',
    'Rock Island',
    'Hanover Park',
    'Carpentersville',
    'Wheeling',
    'Park Ridge',
    'Addison',
    'Calumet City',
  ],
  Texas: [
    'Houston',
    'San Antonio',
    'Dallas',
    'Austin',
    'Fort Worth',
    'El Paso',
    'Arlington',
    'Corpus Christi',
    'Plano',
    'Laredo',
    'Lubbock',
    'Garland',
    'Irving',
    'Amarillo',
    'Grand Prairie',
    'Brownsville',
    'Pasadena',
    'McKinney',
    'Mesquite',
    'McAllen',
    'Killeen',
    'Frisco',
    'Waco',
    'Carrollton',
    'Denton',
    'Midland',
    'Abilene',
    'Beaumont',
    'Round Rock',
    'Odessa',
    'Wichita Falls',
    'Richardson',
    'Lewisville',
    'Tyler',
    'College Station',
    'Pearland',
    'San Angelo',
    'Allen',
    'League City',
    'Sugar Land',
    'Longview',
    'Edinburg',
    'Mission',
    'Bryan',
    'Baytown',
    'Pharr',
    'Temple',
    'Missouri City',
    'Flower Mound',
    'Harlingen',
    'North Richland Hills',
    'Victoria',
    'Conroe',
    'New Braunfels',
    'Mansfield',
    'Cedar Park',
    'Rowlett',
    'Port Arthur',
    'Euless',
    'Georgetown',
    'Pflugerville',
    'DeSoto',
    'San Marcos',
    'Grapevine',
    'Bedford',
    'Galveston',
    'Cedar Hill',
    'Texas City',
    'Wylie',
    'Haltom City',
    'Keller',
    'Coppell',
    'Rockwall',
    'Huntsville',
    'Duncanville',
    'Sherman',
    'The Colony',
    'Burleson',
    'Hurst',
    'Lancaster',
    'Texarkana',
    'Friendswood',
    'Weslaco',
  ],
  Pennsylvania: [
    'Philadelphia',
    'Pittsburgh',
    'Allentown',
    'Erie',
    'Reading',
    'Scranton',
    'Bethlehem',
    'Lancaster',
    'Harrisburg',
    'Altoona',
    'York',
    'State College',
    'Wilkes-Barre',
  ],
  Arizona: [
    'Phoenix',
    'Tucson',
    'Mesa',
    'Chandler',
    'Glendale',
    'Scottsdale',
    'Gilbert',
    'Tempe',
    'Peoria',
    'Surprise',
    'Yuma',
    'Avondale',
    'Goodyear',
    'Flagstaff',
    'Buckeye',
    'Lake Havasu City',
    'Casa Grande',
    'Sierra Vista',
    'Maricopa',
    'Oro Valley',
    'Prescott',
    'Bullhead City',
    'Prescott Valley',
    'Marana',
    'Apache Junction',
  ],
  Florida: [
    'Jacksonville',
    'Miami',
    'Tampa',
    'Orlando',
    'St. Petersburg',
    'Hialeah',
    'Tallahassee',
    'Fort Lauderdale',
    'Port St. Lucie',
    'Cape Coral',
    'Pembroke Pines',
    'Hollywood',
    'Miramar',
    'Gainesville',
    'Coral Springs',
    'Miami Gardens',
    'Clearwater',
    'Palm Bay',
    'Pompano Beach',
    'West Palm Beach',
    'Lakeland',
    'Davie',
    'Miami Beach',
    'Sunrise',
    'Plantation',
    'Boca Raton',
    'Deltona',
    'Largo',
    'Deerfield Beach',
    'Palm Coast',
    'Melbourne',
    'Boynton Beach',
    'Lauderhill',
    'Weston',
    'Fort Myers',
    'Kissimmee',
    'Homestead',
    'Tamarac',
    'Delray Beach',
    'Daytona Beach',
    'North Miami',
    'Wellington',
    'North Port',
    'Jupiter',
    'Ocala',
    'Port Orange',
    'Margate',
    'Coconut Creek',
    'Sanford',
    'Sarasota',
    'Pensacola',
    'Bradenton',
    'Palm Beach Gardens',
    'Pinellas Park',
    'Coral Gables',
    'Doral',
    'Bonita Springs',
    'Apopka',
    'Titusville',
    'North Miami Beach',
    'Oakland Park',
    'Fort Pierce',
    'North Lauderdale',
    'Cutler Bay',
    'Altamonte Springs',
    'St. Cloud',
    'Greenacres',
    'Ormond Beach',
    'Ocoee',
    'Hallandale Beach',
    'Winter Garden',
    'Aventura',
  ],
  Indiana: [
    'Indianapolis',
    'Fort Wayne',
    'Evansville',
    'South Bend',
    'Carmel',
    'Bloomington',
    'Fishers',
    'Hammond',
    'Gary',
    'Muncie',
    'Lafayette',
    'Terre Haute',
    'Kokomo',
    'Anderson',
    'Noblesville',
    'Greenwood',
    'Elkhart',
    'Mishawaka',
    'Lawrence',
    'Jeffersonville',
    'Columbus',
    'Portage',
  ],
  Ohio: [
    'Columbus',
    'Cleveland',
    'Cincinnati',
    'Toledo',
    'Akron',
    'Dayton',
    'Parma',
    'Canton',
    'Youngstown',
    'Lorain',
    'Hamilton',
    'Springfield',
    'Kettering',
    'Elyria',
    'Lakewood',
    'Cuyahoga Falls',
    'Middletown',
    'Euclid',
    'Newark',
    'Mansfield',
    'Mentor',
    'Beavercreek',
    'Cleveland Heights',
    'Strongsville',
    'Dublin',
    'Fairfield',
    'Findlay',
    'Warren',
    'Lancaster',
    'Lima',
    'Huber Heights',
    'Westerville',
    'Marion',
    'Grove City',
  ],
  'North Carolina': [
    'Charlotte',
    'Raleigh',
    'Greensboro',
    'Durham',
    'Winston-Salem',
    'Fayetteville',
    'Cary',
    'Wilmington',
    'High Point',
    'Greenville',
    'Asheville',
    'Concord',
    'Gastonia',
    'Jacksonville',
    'Chapel Hill',
    'Rocky Mount',
    'Burlington',
    'Wilson',
    'Huntersville',
    'Kannapolis',
    'Apex',
    'Hickory',
    'Goldsboro',
  ],
  Michigan: [
    'Detroit',
    'Grand Rapids',
    'Warren',
    'Sterling Heights',
    'Ann Arbor',
    'Lansing',
    'Flint',
    'Dearborn',
    'Livonia',
    'Westland',
    'Troy',
    'Farmington Hills',
    'Kalamazoo',
    'Wyoming',
    'Southfield',
    'Rochester Hills',
    'Taylor',
    'Pontiac',
    'St. Clair Shores',
    'Royal Oak',
    'Novi',
    'Dearborn Heights',
    'Battle Creek',
    'Saginaw',
    'Kentwood',
    'East Lansing',
    'Roseville',
    'Portage',
    'Midland',
    'Lincoln Park',
    'Muskegon',
  ],
  Tennessee: [
    'Memphis',
    'Nashville-Davidson',
    'Knoxville',
    'Chattanooga',
    'Clarksville',
    'Murfreesboro',
    'Jackson',
    'Franklin',
    'Johnson City',
    'Bartlett',
    'Hendersonville',
    'Kingsport',
    'Collierville',
    'Cleveland',
    'Smyrna',
    'Germantown',
    'Brentwood',
  ],
  Massachusetts: [
    'Boston',
    'Worcester',
    'Springfield',
    'Lowell',
    'Cambridge',
    'New Bedford',
    'Brockton',
    'Quincy',
    'Lynn',
    'Fall River',
    'Newton',
    'Lawrence',
    'Somerville',
    'Waltham',
    'Haverhill',
    'Malden',
    'Medford',
    'Taunton',
    'Chicopee',
    'Weymouth Town',
    'Revere',
    'Peabody',
    'Methuen',
    'Barnstable Town',
    'Pittsfield',
    'Attleboro',
    'Everett',
    'Salem',
    'Westfield',
    'Leominster',
    'Fitchburg',
    'Beverly',
    'Holyoke',
    'Marlborough',
    'Woburn',
    'Chelsea',
  ],
  Washington: [
    'Seattle',
    'Spokane',
    'Tacoma',
    'Vancouver',
    'Bellevue',
    'Kent',
    'Everett',
    'Renton',
    'Yakima',
    'Federal Way',
    'Spokane Valley',
    'Bellingham',
    'Kennewick',
    'Auburn',
    'Pasco',
    'Marysville',
    'Lakewood',
    'Redmond',
    'Shoreline',
    'Richland',
    'Kirkland',
    'Burien',
    'Sammamish',
    'Olympia',
    'Lacey',
    'Edmonds',
    'Bremerton',
    'Puyallup',
  ],
  Colorado: [
    'Denver',
    'Colorado Springs',
    'Aurora',
    'Fort Collins',
    'Lakewood',
    'Thornton',
    'Arvada',
    'Westminster',
    'Pueblo',
    'Centennial',
    'Boulder',
    'Greeley',
    'Longmont',
    'Loveland',
    'Grand Junction',
    'Broomfield',
    'Castle Rock',
    'Commerce City',
    'Parker',
    'Littleton',
    'Northglenn',
  ],
  'District of Columbia': ['Washington'],
  Maryland: [
    'Baltimore',
    'Frederick',
    'Rockville',
    'Gaithersburg',
    'Bowie',
    'Hagerstown',
    'Annapolis',
  ],
  Kentucky: [
    'Louisville/Jefferson County',
    'Lexington-Fayette',
    'Bowling Green',
    'Owensboro',
    'Covington',
  ],
  Oregon: [
    'Portland',
    'Eugene',
    'Salem',
    'Gresham',
    'Hillsboro',
    'Beaverton',
    'Bend',
    'Medford',
    'Springfield',
    'Corvallis',
    'Albany',
    'Tigard',
    'Lake Oswego',
    'Keizer',
  ],
  Oklahoma: [
    'Oklahoma City',
    'Tulsa',
    'Norman',
    'Broken Arrow',
    'Lawton',
    'Edmond',
    'Moore',
    'Midwest City',
    'Enid',
    'Stillwater',
    'Muskogee',
  ],
  Wisconsin: [
    'Milwaukee',
    'Madison',
    'Green Bay',
    'Kenosha',
    'Racine',
    'Appleton',
    'Waukesha',
    'Eau Claire',
    'Oshkosh',
    'Janesville',
    'West Allis',
    'La Crosse',
    'Sheboygan',
    'Wauwatosa',
    'Fond du Lac',
    'New Berlin',
    'Wausau',
    'Brookfield',
    'Greenfield',
    'Beloit',
  ],
  Nevada: [
    'Las Vegas',
    'Henderson',
    'Reno',
    'North Las Vegas',
    'Sparks',
    'Carson City',
  ],
  'New Mexico': [
    'Albuquerque',
    'Las Cruces',
    'Rio Rancho',
    'Santa Fe',
    'Roswell',
    'Farmington',
    'Clovis',
  ],
  Missouri: [
    'Kansas City',
    'St. Louis',
    'Springfield',
    'Independence',
    'Columbia',
    "Lee's Summit",
    "O'Fallon",
    'St. Joseph',
    'St. Charles',
    'St. Peters',
    'Blue Springs',
    'Florissant',
    'Joplin',
    'Chesterfield',
    'Jefferson City',
    'Cape Girardeau',
  ],
  Virginia: [
    'Virginia Beach',
    'Norfolk',
    'Chesapeake',
    'Richmond',
    'Newport News',
    'Alexandria',
    'Hampton',
    'Roanoke',
    'Portsmouth',
    'Suffolk',
    'Lynchburg',
    'Harrisonburg',
    'Leesburg',
    'Charlottesville',
    'Danville',
    'Blacksburg',
    'Manassas',
  ],
  Georgia: [
    'Atlanta',
    'Columbus',
    'Augusta-Richmond County',
    'Savannah',
    'Athens-Clarke County',
    'Sandy Springs',
    'Roswell',
    'Macon',
    'Johns Creek',
    'Albany',
    'Warner Robins',
    'Alpharetta',
    'Marietta',
    'Valdosta',
    'Smyrna',
    'Dunwoody',
  ],
  Nebraska: ['Omaha', 'Lincoln', 'Bellevue', 'Grand Island'],
  Minnesota: [
    'Minneapolis',
    'St. Paul',
    'Rochester',
    'Duluth',
    'Bloomington',
    'Brooklyn Park',
    'Plymouth',
    'St. Cloud',
    'Eagan',
    'Woodbury',
    'Maple Grove',
    'Eden Prairie',
    'Coon Rapids',
    'Burnsville',
    'Blaine',
    'Lakeville',
    'Minnetonka',
    'Apple Valley',
    'Edina',
    'St. Louis Park',
    'Mankato',
    'Maplewood',
    'Moorhead',
    'Shakopee',
  ],
  Kansas: [
    'Wichita',
    'Overland Park',
    'Kansas City',
    'Olathe',
    'Topeka',
    'Lawrence',
    'Shawnee',
    'Manhattan',
    'Lenexa',
    'Salina',
    'Hutchinson',
  ],
  Louisiana: [
    'New Orleans',
    'Baton Rouge',
    'Shreveport',
    'Lafayette',
    'Lake Charles',
    'Kenner',
    'Bossier City',
    'Monroe',
    'Alexandria',
  ],
  Hawaii: ['Honolulu'],
  Alaska: ['Anchorage'],
  'New Jersey': [
    'Newark',
    'Jersey City',
    'Paterson',
    'Elizabeth',
    'Clifton',
    'Trenton',
    'Camden',
    'Passaic',
    'Union City',
    'Bayonne',
    'East Orange',
    'Vineland',
    'New Brunswick',
    'Hoboken',
    'Perth Amboy',
    'West New York',
    'Plainfield',
    'Hackensack',
    'Sayreville',
    'Kearny',
    'Linden',
    'Atlantic City',
  ],
  Idaho: [
    'Boise City',
    'Nampa',
    'Meridian',
    'Idaho Falls',
    'Pocatello',
    'Caldwell',
    "Coeur d'Alene",
    'Twin Falls',
  ],
  Alabama: [
    'Birmingham',
    'Montgomery',
    'Mobile',
    'Huntsville',
    'Tuscaloosa',
    'Hoover',
    'Dothan',
    'Auburn',
    'Decatur',
    'Madison',
    'Florence',
    'Gadsden',
  ],
  Iowa: [
    'Des Moines',
    'Cedar Rapids',
    'Davenport',
    'Sioux City',
    'Iowa City',
    'Waterloo',
    'Council Bluffs',
    'Ames',
    'West Des Moines',
    'Dubuque',
    'Ankeny',
    'Urbandale',
    'Cedar Falls',
  ],
  Arkansas: [
    'Little Rock',
    'Fort Smith',
    'Fayetteville',
    'Springdale',
    'Jonesboro',
    'North Little Rock',
    'Conway',
    'Rogers',
    'Pine Bluff',
    'Bentonville',
  ],
  Utah: [
    'Salt Lake City',
    'West Valley City',
    'Provo',
    'West Jordan',
    'Orem',
    'Sandy',
    'Ogden',
    'St. George',
    'Layton',
    'Taylorsville',
    'South Jordan',
    'Lehi',
    'Logan',
    'Murray',
    'Draper',
    'Bountiful',
    'Riverton',
    'Roy',
  ],
  'Rhode Island': [
    'Providence',
    'Warwick',
    'Cranston',
    'Pawtucket',
    'East Providence',
    'Woonsocket',
  ],
  Mississippi: [
    'Jackson',
    'Gulfport',
    'Southaven',
    'Hattiesburg',
    'Biloxi',
    'Meridian',
  ],
  'South Dakota': ['Sioux Falls', 'Rapid City'],
  Connecticut: [
    'Bridgeport',
    'New Haven',
    'Stamford',
    'Hartford',
    'Waterbury',
    'Norwalk',
    'Danbury',
    'New Britain',
    'Meriden',
    'Bristol',
    'West Haven',
    'Milford',
    'Middletown',
    'Norwich',
    'Shelton',
  ],
  'South Carolina': [
    'Columbia',
    'Charleston',
    'North Charleston',
    'Mount Pleasant',
    'Rock Hill',
    'Greenville',
    'Summerville',
    'Sumter',
    'Goose Creek',
    'Hilton Head Island',
    'Florence',
    'Spartanburg',
  ],
  'New Hampshire': ['Manchester', 'Nashua', 'Concord'],
  'North Dakota': ['Fargo', 'Bismarck', 'Grand Forks', 'Minot'],
  Montana: ['Billings', 'Missoula', 'Great Falls', 'Bozeman'],
  Delaware: ['Wilmington', 'Dover'],
  Maine: ['Portland'],
  Wyoming: ['Cheyenne', 'Casper'],
  'West Virginia': ['Charleston', 'Huntington'],
  Vermont: ['Burlington'],
};

export const SUPER_BILL_RAW_DATA = {
  claimLines: [
    {
      createdAt: 1646999306587,
      updatedAt: 1646999306587,
      id: '622b370ad7c3ba92e480aed7',
      dateOfServiceFrom: '2022-02-28',
      dateOfServiceTo: '2022-02-28',
      placeofService: '11',
      procedureCode: 'G8427',
      modifiers: 'A',
      diagnosisPointers: ['K24.56', 'M98.90'],
      units: '1',
      charges: '150',
      claim: '622b370ad7c3ba92e480aed6',
    },
    {
      createdAt: 1646999307003,
      updatedAt: 1646999307003,
      id: '622b370bd7c3ba92e480aed8',
      dateOfServiceFrom: '2022-02-28',
      dateOfServiceTo: '2022-02-28',
      placeofService: '11',
      procedureCode: 'G8429',
      modifiers: 'A',
      diagnosisPointers: ['K24.56', 'M98.90'],
      units: '1',
      charges: '100',
      claim: '622b370ad7c3ba92e480aed6',
    },
  ],
  createdAt: 1646999306215,
  updatedAt: 1646999306215,
  id: '622b370ad7c3ba92e480aed6',
  internlClaimNumber: '1127834776788675',
  externalClaimNumber: '1123453467',
  diagnosisCodes: ['K24.56', 'M98.90'],
  totalCharge: '250',
  status: 'DRAFT',
  documents: null,
  individualRelationship: 'Self',
  claimfillingIndicator: 'Y',
  payerResponsbility: 'Y',
  authorization: 'Y',
  patientAuthorization: 'Yes',
  physicianOrSupplierSignatureIsOnFile: false,
  submitter: {
    createdAt: 1646999125616,
    updatedAt: 1646999125616,
    id: '622b3655d7c3ba92e480aece',
    name: 'ABC Submitter',
    submitterId: '134950',
    phoneNumber: '3467889',
    address: {
      addressLine1: 'submitter Test',
      addressLine2: 'Test 124',
      city: 'New York',
      state: 'NY',
      zip: '117459',
    },
  },
  receiver: {
    createdAt: 1646999125968,
    updatedAt: 1646999125968,
    id: '622b3655d7c3ba92e480aecf',
    name: 'ABC receiver',
    receiverId: '134950',
    phoneNumber: '3467889',
    address: {
      addressLine1: 'receiver Test',
      addressLine2: 'Test 124',
      city: 'New York',
      state: 'NY',
      zip: '117459',
    },
  },
  payer: {
    createdAt: 1646999126328,
    updatedAt: 1646999126328,
    id: '622b3656d7c3ba92e480aed0',
    name: 'ABC payer',
    payerId: '134950',
    externalId: '',
    phoneNumber: '3467889',
    address: {
      addressLine1: 'payer Test',
      addressLine2: 'Test 124',
      city: 'New York',
      state: 'NY',
      zip: '117459',
    },
  },
  subscriber: {
    createdAt: 1646999125011,
    updatedAt: 1646999125011,
    id: '622b3655d7c3ba92e480aecc',
    firstName: 'Sumedh',
    lastName: 'Lam',
    middleName: ' ',
    suffix: 'Mr',
    sex: 'M',
    dob: '1990-05-21',
    ssn: '7887888977787878787',
    phoneNumber: '1248859969',
    address: {
      addressLine1: 'Subscriber Test',
      addressLine2: 'Test 124',
      city: 'New York',
      state: 'NY',
      zip: '117459',
    },
    insuredId: '904XT2654',
    groupNumber: '58686969',
    groupName: 'ABC group',
    policyNumber: '1345666',
  },
  patient: {
    createdAt: 1646999125284,
    updatedAt: 1646999125284,
    id: '622b3655d7c3ba92e480aecd',
    firstName: 'Sumedh',
    lastName: 'Lam',
    middleName: ' ',
    suffix: 'Mr',
    sex: 'M',
    dob: '1990-05-21',
    ssn: '1243456890',
    phoneNumber: '1248859969',
    address: {
      addressLine1: 'Patient Test',
      addressLine2: 'Test 124',
      city: 'New York',
      state: 'NY',
      zip: '117459',
    },
  },
  billingProvider: {
    createdAt: 1646999126601,
    updatedAt: 1646999126601,
    id: '622b3656d7c3ba92e480aed1',
    firstName: 'Pradeep',
    lastName: 'Tandon',
    middleName: ' ',
    suffix: 'Dr',
    sex: 'M',
    phoneNumber: '9998887777',
    npiId: '12437456890',
    taxId: '12437456890',
    address: {
      addressLine1: 'Billing provider Test',
      addressLine2: 'Test 124',
      city: 'New York',
      state: 'NY',
      zip: '117459',
    },
    ssn: '1243456890',
    taxonomyCode: '1243456890',
  },
  renderingProvider: {
    createdAt: 1646999126886,
    updatedAt: 1646999126886,
    id: '622b3656d7c3ba92e480aed2',
    firstName: 'Usha',
    lastName: 'Tandon',
    middleName: ' ',
    suffix: 'Dr',
    sex: 'F',
    phoneNumber: '9998887777',
    npiId: '124345677886899',
    taxId: '124346656890',
    address: {
      addressLine1: 'Rendering provider Test',
      addressLine2: 'Test 124',
      city: 'New York',
      state: 'NY',
      zip: '117459',
    },
    ssn: '1243456890',
    taxonomyCode: '1243456890',
  },
};
